import {
  ActBlueImportIntegration,
  ActBlueWebhookIntegration,
  ActionKitIntegration,
  DDxExportIntegration,
  GcsImportIntegration,
  IntegrationServiceType,
  NgpVanIntegration,
} from "~frontend/__generated__/graphql";

import { ActBlueImportIntegrationSettingsForm } from "./ActBlueImportIntegrationSettingsForm";
import { ActBlueWebhookIntegrationSettingsForm } from "./ActBlueWebhookIntegrationSettingsForm";
import { ActionKitIntegrationSettingsForm } from "./ActionKitIntegrationSettingsForm";
import { DDxIntegrationSettingsForm } from "./DDxIntegrationSettingsForm";
import { GCSImportIntegrationSettingsForm } from "./GCSImportIntegrationSettingsForm";
import { NgpVanIntegrationSettingsForm } from "./NgpVanIntegrationSettingsForm";

// Note: Any new integration types need to be added to this map
export type IntegrationType<K extends IntegrationServiceType> =
  K extends IntegrationServiceType.ActBlueWebhook
    ? ActBlueWebhookIntegration
    : K extends IntegrationServiceType.ActionKit
      ? ActionKitIntegration
      : K extends IntegrationServiceType.ActBlueImport
        ? ActBlueImportIntegration
        : K extends IntegrationServiceType.Ngpvan
          ? NgpVanIntegration
          : K extends IntegrationServiceType.GcsImport
            ? GcsImportIntegration
            : K extends IntegrationServiceType.DdxExport
              ? DDxExportIntegration
              : never;

export const integrationComponents: {
  [K in IntegrationServiceType]: React.ComponentType<{
    integration: IntegrationType<K> | null;
    subaccountId: string;
    afterCreate?: () => void;
    onClose: () => void;
  }>;
} = {
  ACTION_KIT: ActionKitIntegrationSettingsForm,
  GCS_IMPORT: GCSImportIntegrationSettingsForm,
  ACT_BLUE_WEBHOOK: ActBlueWebhookIntegrationSettingsForm,
  ACT_BLUE_IMPORT: ActBlueImportIntegrationSettingsForm,
  NGPVAN: NgpVanIntegrationSettingsForm,
  DDX_EXPORT: DDxIntegrationSettingsForm,
};

export type IntegrationComponentType<T extends IntegrationServiceType> =
  React.ComponentType<{
    integration: IntegrationType<T> | null;
    onClose: () => void;
    afterCreate?: () => void;
    subaccountId: string;
  }>;

export const integrationLabels: { [K in IntegrationServiceType]: string } = {
  ACTION_KIT: "ActionKit",
  GCS_IMPORT: "Google Cloud Storage Import",
  ACT_BLUE_WEBHOOK: "ActBlue Donation Webhook",
  ACT_BLUE_IMPORT: "ActBlue Import",
  NGPVAN: "NGP VAN / EveryAction",
  DDX_EXPORT: "Democratic Data Exchange",
};
